"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupApiErrorCode = exports.ApplicationMonitoringErrorCode = exports.UIErrorCode = exports.RequestFailureErrorCode = exports.ClientValidationErrorCode = void 0;
/**
 * Error Codes denoting that the error is caused due to a mistake made from the client's end
 */
var ClientValidationErrorCode;
(function (ClientValidationErrorCode) {
    ClientValidationErrorCode["EMAIL_ERROR"] = "EMAIL_ERROR";
    ClientValidationErrorCode["INVALID_FIELD"] = "INVALID_FIELD";
    ClientValidationErrorCode["INVALID_SALES_ASSISTED_URL"] = "INVALID_SALES_ASSISTED_URL";
    ClientValidationErrorCode["SUPPRESSED_COUNTRY"] = "SUPPRESSED_COUNTRY";
    ClientValidationErrorCode["SUPPRESSED_EMAIL"] = "SUPPRESSED_EMAIL";
    ClientValidationErrorCode["SUPPRESSED_GENERIC"] = "SUPPRESSED_GENERIC";
    ClientValidationErrorCode["AZURE_INVALID_TOKEN"] = "AZURE_INVALID_TOKEN";
    ClientValidationErrorCode["AZURE_SUBSCRIPTION_ALREADY_ACTIVATED"] = "AZURE_SUBSCRIPTION_ALREADY_ACTIVATED";
    ClientValidationErrorCode["PROGRAM_SIGNUP_ALREADY_USED"] = "PROGRAM_SIGNUP_ALREADY_USED";
    ClientValidationErrorCode["PROGRAM_SIGNUP_NOT_APPROVED"] = "PROGRAM_SIGNUP_NOT_APPROVED";
    ClientValidationErrorCode["GENERIC_ERROR_AWS_MARKETPLACE"] = "GENERIC_ERROR_AWS_MARKETPLACE";
    ClientValidationErrorCode["NOT_FOUND"] = "NOT_FOUND";
    ClientValidationErrorCode["INVALID_GLOBAL_LISTING_ID"] = "INVALID_GLOBAL_LISTING_ID";
    ClientValidationErrorCode["INVALID_LISTING_SOURCE_DEPLOYMENT"] = "INVALID_LISTING_SOURCE_DEPLOYMENT";
    ClientValidationErrorCode["GENERIC_HTTP_ERROR"] = "GENERIC_HTTP_ERROR";
    ClientValidationErrorCode["MISSING_LISTING_ID"] = "MISSING_LISTING_ID";
    ClientValidationErrorCode["INVALID_RECAPTCHA_TOKEN"] = "INVALID_RECAPTCHA_TOKEN";
    ClientValidationErrorCode["INVALID_TELEMETRY"] = "INVALID_TELEMETRY";
    ClientValidationErrorCode["INVALID_MANUAL_OVERRIDE_COOKIE"] = "INVALID_MANUAL_OVERRIDE_COOKIE";
})(ClientValidationErrorCode || (exports.ClientValidationErrorCode = ClientValidationErrorCode = {}));
/**
 * Error Codes denoting a server side error that could cause a request failure
 */
var RequestFailureErrorCode;
(function (RequestFailureErrorCode) {
    // Currently Generic Errors are being used haphardzly throughout the code base
    // Generic Errors should be replaced with RequestFailureErrorCode and ApplicationMonitoringErrorCodes
    RequestFailureErrorCode["GENERIC_ERROR"] = "GENERIC_ERROR";
    RequestFailureErrorCode["POST_ACCOUNT_CREATION_ERROR"] = "POST_ACCOUNT_CREATION_ERROR";
    RequestFailureErrorCode["SALESFORCE_API_ERROR"] = "SALESFORCE_API_ERROR";
    // The AWS Marketplace dedup claim could not be evaluated (e.g. Snowhouse error). The signup is
    // rejected (fail closed) rather than risking a duplicate org; the client can retry. Distinct
    // from GENERIC_ERROR_AWS_MARKETPLACE, which means the identifier was already consumed.
    RequestFailureErrorCode["AWS_MARKETPLACE_DEDUP_UNAVAILABLE"] = "AWS_MARKETPLACE_DEDUP_UNAVAILABLE";
})(RequestFailureErrorCode || (exports.RequestFailureErrorCode = RequestFailureErrorCode = {}));
/**
 * Error Codes denoting that an error is being logged on behalf of the Signup UI
 */
var UIErrorCode;
(function (UIErrorCode) {
    UIErrorCode["UI_TELEMETRY_ERROR"] = "UI_TELEMETRY_ERROR";
})(UIErrorCode || (exports.UIErrorCode = UIErrorCode = {}));
/**
 * Error Codes denoting that an error does not cause request failures but still needs reporting
 */
var ApplicationMonitoringErrorCode;
(function (ApplicationMonitoringErrorCode) {
    ApplicationMonitoringErrorCode["CONNECTION_FAILED"] = "CONNECTION_FAILED";
    ApplicationMonitoringErrorCode["WAVEFRONT_ERROR"] = "WAVEFRONT_ERROR";
    ApplicationMonitoringErrorCode["IP_QUALITY_SCORE_API_ERROR"] = "IP_QUALITY_SCORE_API_ERROR";
    ApplicationMonitoringErrorCode["INVALID_DEPLOYMENT_METADATA"] = "INVALID_DEPLOYMENT_METADATA";
    ApplicationMonitoringErrorCode["SUPPRESSION_RULE_FETCH_ERROR"] = "SUPPRESSION_RULE_FETCH_ERROR";
})(ApplicationMonitoringErrorCode || (exports.ApplicationMonitoringErrorCode = ApplicationMonitoringErrorCode = {}));
exports.SignupApiErrorCode = Object.assign(Object.assign(Object.assign(Object.assign({}, UIErrorCode), ClientValidationErrorCode), RequestFailureErrorCode), ApplicationMonitoringErrorCode);
//# sourceMappingURL=error.js.map